import composeRequest, {
  authHeaders,
  header,
  hostHeaders,
  method,
  query,
  urlTagged,
} from 'api/helpers';
import { identity } from 'lodash-es';

export function newSearchRequest({
  ampUrl,
  host,
  params,
  profileId,
  sessionId,
  searchVariant,
}: {
  ampUrl: string;
  host: string;
  params: any;
  profileId: string | number;
  sessionId: string;
  searchVariant?: string;
}) {
  return composeRequest(
    method('get'),
    urlTagged`${{ ampUrl }}/api/v3/search/combined`,
    query({ ...params }),
    authHeaders(profileId, sessionId),
    hostHeaders(host),
    searchVariant ? header('X-Search-Variant-ID', `searchVariant${searchVariant}`) : identity
  )();
}
